<template>
  <div class="d-ib">
    <el-badge is-dot :hidden="filtersEmpty()">
      <el-button
        type="primary"
        class="btn-main"
        icon="el-icon-search"
        @click="openDialog()"
      >
        Filters
      </el-button>
    </el-badge>
    <el-dialog
      title="Filters"
      :visible.sync="dialog"
      width="500px"
      top="3vh"
      :modal="false"
    >
      <el-input
        type="text"
        v-model="first_name"
        clearable
        placeholder="First name"
      />
      <el-input
        type="text"
        v-model="surname"
        clearable
        placeholder="Last name"
        class="mt10"
      />
      <div class="email-wrap mt10">
        <el-input type="text" v-model="email" clearable placeholder="E-mail"/>
        <el-checkbox class="ml10" v-model="affiliate" label="Affiliate" border></el-checkbox>
      </div>
      <el-select
        v-model="country"
        placeholder="Country"
        clearable
        filterable
        default-first-option
        class="mt10 w100"
      >
        <el-option
          v-for="(c, i) in countries"
          :key="i"
          :label="c.name"
          :value="c.iso"
        ></el-option>
      </el-select>
      <el-select
        v-model="company_admin"
        placeholder="Company Admin"
        clearable
        filterable
        default-first-option
        class="mt10 w100"
        v-if="activeTab === 'mcn'"
      >
        <el-option
          v-for="c in companyAdmins"
          :key="c.id"
          :label="c.name"
          :value="c.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="user_level"
        placeholder="User type"
        clearable
        filterable
        default-first-option
        class="mt10 w100"
        v-if="activeTab === 'all'"
      >
        <el-option
          v-for="(r, i) in user_levels"
          :key="i"
          :label="r.title"
          :value="r.slug"
        ></el-option>
      </el-select>
      <el-select
          v-if="activeTab === 'all' || activeTab === 'creators' || activeTab === 'mcn'"
          v-model="creatorTier" placeholder="Tier" clearable filterable class="mt10 w100">
        <el-option v-for="tier in creatorTiers" :key="tier.id" :label="tier.name" :value="tier.name"></el-option>
      </el-select>
      <el-select
        v-model="user_tier"
        placeholder="User level"
        clearable
        filterable
        default-first-option
        class="mt10 w100"
      >
        <el-option
          v-for="(t, i) in tiers"
          :key="i"
          :label="t.name"
          :value="t.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="ytCategory"
        placeholder="YouTube Category"
        clearable
        filterable
        class="mt10 w100"
      >
        <el-option
          v-for="(category, i) in ytCategories"
          :key="i"
          :label="category.name"
          :value="category.id"
        ></el-option>
        <el-option label="No Category" value="no_category"></el-option>
      </el-select>
      <el-select v-model="hasChannel" placeholder="Has YouTube Channel" clearable class="mt10 w100">
        <el-option label="Yes" :value="true"></el-option>
        <el-option label="No" :value="false"></el-option>
      </el-select>
      <el-select v-if="activeTab === 'all' || activeTab === 'creators' || activeTab === 'mcn'"
          v-model="socialNetwork" @change="onSocialsChange()" placeholder="Select Social Network" clearable class="mt10 w100">
        <el-option-group v-for="(value, key) in socialNetworks" :key="key" :label="value">
          <span class="social-select-label">{{ value }}</span>
          <el-option label="Pending" :value="`${key}-0`"></el-option>
          <el-option label="Approved" :value="`${key}-1`"></el-option>
          <el-option label="Rejected" :value="`${key}-2`"></el-option>
          <el-option label="OTW" :value="`${key}-3`"></el-option>
        </el-option-group>
      </el-select>
      <el-date-picker
        v-model="date_range"
        type="daterange"
        class="mt10"
        unlink-panels
        range-separator="-"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="dateRangeOptions"
        format="d MMMM yyyy"
        value-format="yyyy-MM-dd"
        @change="filter()"
      ></el-date-picker>
      <el-checkbox class="no-platforms" v-model="noPlatforms" @change="noPlatformsChange" label="Has no platforms added" border></el-checkbox>
      <div slot="footer">
        <!-- <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button> -->
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import isNull from 'lodash/isNull'

export default {
  data() {
    return {
      dialog: false,
      first_name: '',
      surname: '',
      email: '',
      country: '',
      date_range: '',
      user_level: '',
      user_tier: '',
      company_admin: '',
      user_levels: [
        { title: 'Sysadmin', slug: 'sysadmin' },
        { title: 'Artist Admin', slug: 'artist_admin' },
        { title: 'Label Admin', slug: 'label_admin' },
        { title: 'Company User', slug: 'company_user' },
        { title: 'Manager Admin', slug: 'manager_admin' },
        { title: 'Company Admin', slug: 'company_admin' },
        { title: 'Creator User', slug: 'user' },
        { title: 'Verified Creator', slug: 'creator' }
      ],
      vc_applications: [
        { id: 1, name: 'Approved' },
        { id: 2, name: 'Rejected' },
        { id: 3, name: 'Waiting for approval' }
      ],
      socialNetworks: { youtube: 'YouTube', instagram: 'Instagram', tiktok: 'TikTok' },
      ytCategory: null,
      creatorTier: null,
      affiliate: false,
      noPlatforms: false,
      hasChannel: null,
      socialNetwork: null
    }
  },

  props: {
    activeTab: { type: String, required: true }
  },

  computed: {
    ...mapState('global', ['countries']),
    ...mapState('user', ['companyAdmins', 'ytCategories', 'creatorTiers'])
  },

  methods: {
    ...mapActions('user', ['read']),
    ...mapActions('global', ['readCountries']),
    ...mapActions('artistUsers', ['readArtistUsers']),
    ...mapActions('labelUsers', ['readLabelUsers']),
    ...mapMutations('user', ['setPage', 'setPageSize', 'setDateRange']),
    ...mapMutations('artistUsers', ['setArtistPage']),
    ...mapMutations('labelUsers', ['setLabelPage']),
    ...mapActions('creatorUsers', ['readCreatorUsers']),
    ...mapMutations('creatorUsers', ['setCreatorPage']),
    ...mapActions('mcnUsers', ['readMcnUsers']),
    ...mapMutations('mcnUsers', ['setMcnPage']),

    filter() {
      if (this.email && this.affiliate) {
        if (!this.email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )) {
          this.$message({
            message: 'Please provide valid email address for affiliate option', type: 'error'
          })
          return
        }
      }
      this.setPage(1)
      this.setArtistPage(1)
      this.setLabelPage(1)
      this.setCreatorPage(1)
      this.setMcnPage(1)
      let filter_data = {
        first_name: this.first_name,
        surname: this.surname,
        email: this.email,
        country: this.country,
        user_level: this.user_level,
        user_tier: this.user_tier,
        date_start: this.date_range ? this.date_range[0] : "",
        date_end: this.date_range ? this.date_range[1] : "",
        company_admin: this.company_admin,
        ytCategory: this.ytCategory,
        creatorTier: this.creatorTier,
        affiliate: this.affiliate,
        no_platforms: this.noPlatforms,
        hasChannel: this.hasChannel,
        socialNetwork: this.socialNetwork
      }
      localStorage.setItem('user_filter', JSON.stringify(filter_data))
      this.read()
      this.readArtistUsers()
      this.readLabelUsers()
      this.readCreatorUsers()
      this.readMcnUsers()
      this.filtersEmpty()
      this.dialog = false
    },

    filtersEmpty() {
      let ls = JSON.parse(localStorage.getItem('user_filter'))
      if (ls) {
        const { ...active_filters } = ls

        let f = Object.entries(active_filters).filter(value => {
          return value[1] || (value[0] === 'hasChannel' && value[1] === false)
        })
        if (f != null && f.length) return false
      }
      return true
    },

    onSocialsChange() {
      this.noPlatforms = false;
    },

    noPlatformsChange () {
      if (this.noPlatforms === true) {
        this.socialNetwork = null;
      }
    },

    openDialog() {
      this.dialog = true

      let ls = localStorage.getItem('user_filter')
      let f = JSON.parse(ls)

      if (!isNull(f)) {
        this.first_name = f.first_name
        this.surname = f.surname
        this.email = f.email
        this.country = f.country
        this.user_level = f.user_level
        this.user_tier = f.user_tier
        this.subscription_plan = f.subscription_plan
        this.date_start = f.date_start
        this.date_end = f.date_end
        this.company_admin = f.company_admin
        this.ytCategory = f.ytCategory
        this.creatorTier = f.creatorTier
        this.affiliate = f.affiliate
        this.hasChannel = f.hasChannel
        this.socialNetwork = f.socialNetwork
      }
    },

    clear() {
      this.read()
      this.first_name = ''
      this.surname = ''
      this.email = ''
      this.country = ''
      this.date_range = ''
    },
  },

  created() {
    this.readCountries()
    this.filtersEmpty()
  }
}
</script>

<style lang="scss">
.social-select-label {
  display: block;
  padding: 5px 10px;
}
.no-platforms {
  margin-top: 10px;
  width: 100%;
  border-radius: 10px;
  border-color: #868292 !important;
  .el-checkbox__inner {
    border-color: #868292 !important;
  }
}
.el-date-editor--daterange.el-input__inner {
  width: 360px;
}
.email-wrap {
  display: flex;
  align-items: center;

  .el-checkbox {
    border-radius: 10px;
  }
  .el-checkbox.is-bordered.is-checked,
  .el-checkbox__input.is-focus,
  .el-checkbox__inner {
    border-color: #868292 !important;
  }

  .el-checkbox__inner:hover {
    border-color: #868292;
  }
  .error-message {
    margin: 0;
    font-size: 12px;
    color: #d40c41;
  }
}
</style>
